import { render, staticRenderFns } from "./UserProfit.vue?vue&type=template&id=3bf1788e&scoped=true"
import script from "./UserProfit.vue?vue&type=script&lang=js"
export * from "./UserProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1788e",
  null
  
)

export default component.exports